var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("FormItem", {
    scopedSlots: _vm._u(
      [
        {
          key: "question",
          fn: function () {
            return [_vm._v("Order Summary")]
          },
          proxy: true,
        },
        {
          key: "response",
          fn: function () {
            return [
              _c(
                "v-card",
                {
                  staticClass: "soli-round stripe-shadow",
                  attrs: { outlined: "" },
                },
                [
                  _c(
                    "v-list",
                    { staticClass: "px-3", attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "pb-0 justify-start flex" },
                            [_vm._v("Subtotal")]
                          ),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "flex justify-end" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.formatUnitAmount(_vm.subtotal)) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "pb-0 justify-start flex" },
                            [_vm._v("Tax")]
                          ),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "flex justify-end" },
                            [
                              _vm._v(
                                "\n                        $0.00\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.appliedGift
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "justify-start flex" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      `${
                                        _vm.appliedGift.code
                                      } · ${_vm.formatUnitAmount(
                                        _vm.appliedGift.amount
                                      )}`
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "justify-end flex" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      `- ${_vm.formatUnitAmount(
                                        _vm.appliedGift.amount
                                      )}`
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.autoCoupons.length
                        ? _c("v-list-item", [
                            _c(
                              "div",
                              { staticClass: "flex flex-col pt-3" },
                              [
                                _c(
                                  "v-list-item-subtitle",
                                  { staticClass: "justify-start flex" },
                                  [_vm._v("Discounts:")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.autoCoupons, function (coupon) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: coupon.auto_coupon_name,
                                      staticClass: "w-full pr-0 py-0",
                                    },
                                    [
                                      _c(
                                        "v-list-item-subtitle",
                                        { staticClass: "justify-start flex" },
                                        [
                                          _vm._v(
                                            _vm._s(coupon.auto_coupon_name)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-subtitle",
                                        { staticClass: "justify-end flex" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              `- ${coupon.auto_coupon_amount_format}`
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.appliedPromo
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "justify-start flex" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      `${_vm.appliedPromo.code} · ${_vm.appliedPromo.name}`
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "justify-end flex" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      `- ${_vm.formatUnitAmount(
                                        _vm.appliedPromo.amount
                                      )}`
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.appliedBalance
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "pb-0 justify-start flex" },
                                [_vm._v("Account Balance")]
                              ),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "flex justify-end" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.formatUnitAmount(_vm.appliedBalance)
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "pb-0 justify-start flex" },
                            [_vm._v("Amount Due")]
                          ),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-list-item-title",
                            {
                              staticClass:
                                "flex justify-end title soli-grey py-3",
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.formatUnitAmount(_vm.totalAmountDue)
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.totalAmountDue &&
              _vm.items.some(
                (item) => item.lesson_id && !item.event_register_id
              )
                ? _c("div", { staticClass: "mt-4 px-1" }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "text-sm mb-0 text-align-start soli-grey px-1",
                      },
                      [
                        _vm._v(
                          "\n                A payment method is required to register for this class.\n                Your card will not be charged.\n            "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("submit"),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }